import { Truck } from "lucide-react";

import theme from "../../styles/__theme";

import {
	LoaderContainer,
	CircularLoader,
	SvgContainer,
	CircularTrack,
	CircularProgress,
	IconContainer,
	LoadingText,
} from "./Loader.styles";

const { colors } = theme;

/**
 * Loader component with circular progress indicator
 *
 * @returns {JSX.Element} JSX of loader
 */
export default function Loader() {
	return (
		<LoaderContainer>
			<CircularLoader>
				<SvgContainer viewBox="0 0 80 80">
					<CircularTrack cx="40" cy="40" r="36" />
					<CircularProgress cx="40" cy="40" r="36" />
				</SvgContainer>
				<IconContainer>
					<Truck size={24} color={colors.purple} strokeWidth={2} />
				</IconContainer>
			</CircularLoader>
			<LoadingText>Loading...</LoadingText>
		</LoaderContainer>
	);
}
